module.exports = __webpack_public_path__ + "assets/images/02-active_522dd85c74f485adad0cd53b007d2d93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/exercise-4/02-active.png
// module id = 251
// module chunks = 0